/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceSupabase - A library for working with supabase made in Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.
*/

import { Injectable } from "@angular/core";
import type { ItemsService } from "@app/@classes/abstract/items-service-interface";
import { ItemsTableServiceBase } from "@app/@classes/abstract/items-table-service";
import type { Tables } from "@app/@classes/supabase";
import { type Observable, from } from "rxjs";

const TABLE = "bug_reports";
type T = typeof TABLE;

@Injectable({
	providedIn: "root",
})
export class BugReportsService
	extends ItemsTableServiceBase<Tables<T>>
	implements ItemsService<Tables<T>>
{
	constructor() {
		super(TABLE, { hasTenant: true });
	}

	override defaultItem(): Tables<T> {
		return {
			id: this.randomUUID(),
			user_id: null,
			notes: "",
			logs: [],
			attachments: [],
			tenant_id: null,
			updated_at: null,
			created_at: null,
			updated_by: null,
			created_by: null,
		};
	}

	public sendBugReport(item: {
		user_id: string;
		tenant_id: string;
		attachments: string[];
		logs: {
			// biome-ignore lint/suspicious/noExplicitAny: <explanation>
			data?: any;
			description: string;
		}[];
		notes: string;
		project_name: string;
	}) {
		return from(
			this.trpcService.client.reportBug.mutate({
				user_id: item.user_id,
				attachments: item.attachments,
				logs: item.logs,
				notes: item.notes,
				project_name: item.project_name,
				tenant_id: item.tenant_id,
			}),
		);

		// return from(
		// 	this.supabaseClient.functions.invoke("reportBug", {
		// 		body: item,
		// 	}),
		// );
	}
}
